import { Component, OnDestroy } from '@angular/core';

import { ICellRendererAngularComp } from 'ag-grid-angular';

@Component({
    // tslint:disable-next-line:component-selector
    selector: 'btn-cell-renderer',
    template:
        `<style>
        .edit-btn{
            color: white;
            background:rgb(19, 23, 216);
            margin-right:5px
        }
        .del-btn{
            color: white;
            background: red;
        }
        i{
            color: white;
        }    
        .btn:disabled{
            opacity:0.5
        }
        .btn{
            border: none;
            border-radius: 20px;
            cursor:pointer;
        }
    </style>
    <button class="edit-btn btn"  mat-icon-button  (click)="onClickEdit($event)">
    <i class="fa fa-pencil-square-o" aria-hidden="true" style="padding:9px;font-size:18px;"></i>
    </button>

    <button class="del-btn btn"  mat-icon-button  (click)="onClickDelete($event)">
    <i class="fa fa-trash" aria-hidden="true" style="padding:9px;font-size:18px;"></i>
    </button>
    `
})

export class ButtonEditDeleteBtnRenderer implements ICellRendererAngularComp, OnDestroy {
    params: any;
    refresh(params: any): boolean {
        throw new Error('Method not implemented.');
    }

    agInit(params: any): void {
        this.params = params;
    }

    onClickEdit($event: any): any {

        if (this.params.onClickEdit instanceof Function) {
            // put anything into params u want pass into parents component
            const params = {
                event: $event,
                rowData: this.params.node.data,
                index: this.params.node.rowIndex
                // ...something
            };
            this.params.onClickEdit(params);
        }
    }
    onClickDelete($event: any): any {

        if (this.params.onClickDelete instanceof Function) {
            // put anything into params u want pass into parents component
            const params = {
                event: $event,
                rowData: this.params.node.data,
                index: this.params.node.rowIndex
                // ...something
            };
            this.params.onClickDelete(params);
        }
    }
    ngOnDestroy(): any {
        // no need to remove the button click handler
        // https://stackoverflow.com/questions/49083993/does-angular-automatically-remove-template-event-listeners
    }
}